import AccountingEntry from './views/AccountingEntry.vue'
import AccountingProvisions from './views/AccountingProvisions.vue'
import AllowancesAndDeductions from './views/AllowancesAndDeductions.vue'
import Asoveritas from './views/personalized/Asoveritas.vue'
import BacFormato11 from './views/banks/BacFormato11.vue'
import BacFormato17 from './views/banks/BacFormato17.vue'
import Bancomer232 from './views/banks/Bancomer-232.vue'
import BanamexD from './views/banks/Banamex-D.vue'
import BacSanJoseFormato06 from './views/banks/BacSanJoseFormato06.vue'
import BacSanJoseFormato06HN from './views/banks/BacSanJoseFormato06HN.vue'
import BiCustom from './views/BiCustom.vue'
import Bonus from './views/Bonus.vue'
import CCSS from './views/external/CCSS.vue'
import CitibankCR from './views/banks/CitibankCR.vue'
import CitibankUY from './views/banks/CitibankUY.vue'
import CitibankCRV3 from './views/banks/CitibankUY.vue'
import Comparative from './views/Comparative.vue'
import ComparativeConcept from './views/personalized/ComparativeConcept.vue'
import ConceptBases from './views/ConceptBases.vue'
import ConceptDetails from './views/ConceptDetails.vue'
import CostaRicaBankBCR from './views/banks/CostaRicaBankBCR.vue'
import CustomizedPayroll from './views/CustomizedPayroll.vue'
import DaviviendaCR from './views/banks/DaviviendaCR.vue'
import EmbargoesAndLoans from './views/EmbargoesAndLoans.vue'
import FamilyData from './views/FamilyData.vue'
import G2N from './views/personalized/G2N.vue'
import G2NCloudPay from './views/G2NCloudPay.vue'
import GeneralBank from './views/banks/GeneralBank.vue'
import GTN from './views/personalized/GTN.vue'
import HighLow from './views/HighLowReport.vue'
import Historical from './views/Historical.vue'
import INS from './views/external/INS.vue'
import Incidents from './views/Incidents.vue'
import ISRHonduras from './views/banks/ISRHonduras.vue'
import IRPF from './views/external/IRPF.vue'
import Lafise from './views/banks/LafiseSA.vue'
import LafiseV3 from './views/banks/LafiseV3.vue'
import LafiseV3HN from './views/banks/LafiseV3HN.vue'
import LafiseTxt from './views/banks/LafiseTxt.vue'
import PromericaTxt from './views/banks/PromericaTxt.vue'
import LCI from './views/personalized/LCI.vue'
import MainReports from './views/MainReports.vue'
import MainInternalReports from './views/MainInternalReports.vue'
import Magistery from './views/personalized/Magistery.vue'
import NationalBankCostaRica from './views/banks/NationalBankCostaRica.vue'
import NationalBankCostaRicaSINPE from './views/banks/NationalBankCostaRicaSINPE.vue'
import Net from './views/Net.vue'
import Pagus from './views/personalized/Pagus.vue'
import PaylinkCR from './views/banks/PaylinkCR.vue'
import PayRegister from './views/personalized/PayRegister.vue'
import PayrollStandard from './views/PayrollStandard.vue'
import PrevisionSocialBankUY from './views/external/PrevisionSocialBankUY.vue'
import SalaryHistoric from './views/SalaryHistoric.vue'
import SantanderBankUY from './views/banks/SantanderBankUY.vue'
import ScotiabankCR from './views/banks/ScotiabankCR.vue'
import StandardEmployees from './views/StandardEmployees.vue'
import StandardVacation from './views/StandardVacation.vue'
import RAP from './views/banks/RAP.vue'
import VacationBalance from './views/VacationBalance.vue'
import VacationMSC from './views/personalized/VacationMSC.vue'
import BancomerFile108 from './views/banks/BancomerFile108.vue'
import BanamexTypeC from './views/banks/BanamexTypeC.vue'
import BanamexPaylink484 from './views/banks/BanamexPaylink484.vue'
import BanamexPaylink485 from './views/banks/BanamexPaylink485.vue'
import VacationsAccrual from './views/personalized/VacationsAccrual.vue'
import Embargoes from './views/personalized/Embargoes.vue'
import PayEmployees from './views/personalized/PayEmployees.vue'
import IncomeTax from './views/IncomeTax.vue'
import Variability from './views/personalized/Variability.vue'
import SummaryPayments from './views/personalized/SummaryPayments.vue'
import BACSBA from './views/banks/BACSBA.vue'
import HeadcountRegional from './views/personalized/HeadcountRegional.vue'
import SummaryConcepts from './views/personalized/SummaryConcepts.vue'
import SummaryComparative from './views/personalized/SummaryComparative.vue'
import AnnualAccumulative from './views/personalized/AnnualAccumulative.vue'
import ISN from './views/personalized/ISN.vue'
import External from './views/External.vue'
import ConfigureReports from './views/ConfigureReports.vue'
import SUAWorkers from './views/external/SUAWorkers.vue'
import SUAAffiliations from './views/external/SUAAffiliations.vue'
import SUALicenses from './views/external/SUALicenses.vue'
import SUALoans from './views/external/SUALoans.vue'
import SUAMovements from './views/external/SUAMovements.vue'
import InfonacotCertification from './views/external/InfonacotCertification.vue'
import InfonacotIdentification from './views/external/InfonacotIdentification.vue'
import GoSocket4 from './views/personalized/GoSocket4.vue'
import GoSocketRetimbrado from './views/personalized/GoSocketRetimbrado.vue'
import IDSEJoining from './views/external/IDSEJoining.vue'
import IDSELeaving from './views/external/IDSELeaving.vue'
import IDSESalaries from './views/external/IDSESalaries.vue'
import InfonacotCredit from './views/external/InfonacotCredit.vue'
import RentTemplate from './views/external/RentTemplate.vue'
import PaylinkHN from './views/banks/paylinkHN.vue'

export const ReportsRoutes = [
  {
    path: '/reports/accounting-entry/:code',
    name: 'AccountingEntry',
    component: AccountingEntry,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/accounting-provisions/:code',
    name: 'AccountingProvisions',
    component: AccountingProvisions,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/allowances-deductions/:code',
    name: 'AllowancesAndDeductions',
    component: AllowancesAndDeductions,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/asoveritas/:code',
    name: 'Asoveritas',
    component: Asoveritas,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/bac-11/:code',
    name: 'BacFormato11',
    component: BacFormato11,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/bac-17/:code',
    name: 'BacFormato17',
    component: BacFormato17,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/bac-06/:code',
    name: 'BacSanJoseFormato06',
    component: BacSanJoseFormato06,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/bac-06-hr/:code',
    name: 'BacSanJoseFormato06HN',
    component: BacSanJoseFormato06HN,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/custom/:code',
    name: 'BiCustom',
    component: BiCustom,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/external/:code',
    name: 'External',
    component: External,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/average-bonus/:code',
    name: 'Bonus',
    component: Bonus,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/ccss/:code',
    name: 'CCSS',
    component: CCSS,
    meta: {
      auth: false,
      layout: 'home'
    }
  },
  {
    path: '/reports/sua-workers/:code',
    name: 'SUAWorkers',
    component: SUAWorkers,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/sua-affiliations/:code',
    name: 'SUAAffiliations',
    component: SUAAffiliations,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/sua-licenses/:code',
    name: 'SUALicenses',
    component: SUALicenses,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/sua-loans/:code',
    name: 'SUALoans',
    component: SUALoans,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/sua-movements/:code',
    name: 'SUAMovements',
    component: SUAMovements,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/go-socket-4/:code',
    name: 'GoSocket4',
    component: GoSocket4,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/go-socket-retimbrado/:code',
    name: 'GoSocketRetimbrado',
    component: GoSocketRetimbrado,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/idse-joining/:code',
    name: 'IDSEJoining',
    component: IDSEJoining,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/idse-leaving/:code',
    name: 'IDSELeaving',
    component: IDSELeaving,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/idse-salaries/:code',
    name: 'IDSESalaries',
    component: IDSESalaries,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/citibank/:code',
    name: 'CitibankCR',
    component: CitibankCR,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/citibank-uy/:code',
    name: 'CitibankUY',
    component: CitibankUY,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/bac-sba/:code',
    name: 'BACSBA',
    component: BACSBA,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/citibank-cr/:code',
    name: 'CitibankCRV3',
    component: CitibankCRV3,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/comparative/:code',
    name: 'Comparative',
    component: Comparative,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/comparative-concept/:code',
    name: 'ComparativeConcept',
    component: ComparativeConcept,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/concept-bases/:code',
    name: 'ConceptBases',
    component: ConceptBases,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/concept-details/:code',
    name: 'ConceptDetails',
    component: ConceptDetails,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/summary-concepts/:code',
    name: 'SummaryConcepts',
    component: SummaryConcepts,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/summary-comparative/:code',
    name: 'SummaryComparative',
    component: SummaryComparative,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/annual-accumulative/:code',
    name: 'AnnualAccumulative',
    component: AnnualAccumulative,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/isn/:code',
    name: 'ISN',
    component: ISN,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/bcr/:code',
    name: 'CostaRicaBankBCR',
    component: CostaRicaBankBCR,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/customized-payroll/:code',
    name: 'CustomizedPayroll',
    component: CustomizedPayroll,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/variability/:code',
    name: 'Variability',
    component: Variability,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/davivienda-bank/:code',
    name: 'Davivienda',
    component: DaviviendaCR,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/liens-loans/:code',
    name: 'EmbargoesAndLoans',
    component: EmbargoesAndLoans,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/embargo/:code',
    name: 'Embargo',
    component: Embargoes,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/family-data/:code',
    name: 'FamilyData',
    component: FamilyData,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/g2n/:code',
    name: 'G2N',
    component: G2N,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/g2n-cloudpay',
    name: 'G2NCloudPay',
    component: G2NCloudPay,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/general-bank/:code',
    name: 'GeneralBankCR',
    component: GeneralBank,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/gtn/:code',
    name: 'GTN',
    component: GTN,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/arrivals-retirement/:code',
    name: 'HighLow',
    component: HighLow,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/historical/:code',
    name: 'Historical',
    component: Historical,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/income-tax/:code',
    name: 'IncomeTax',
    component: IncomeTax,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/ins/:code',
    name: 'INS',
    component: INS,
    meta: {
      auth: false,
      layout: 'home'
    }
  },
  {
    path: '/reports/incidents/:code',
    name: 'Incidents',
    component: Incidents,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/isr-hn/:code',
    name: 'ISRHonduras',
    component: ISRHonduras,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/irpf/:code',
    name: 'IRPF',
    component: IRPF,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/lafise-bank/:code',
    name: 'Lafise',
    component: Lafise,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/lafise-v3/:code',
    name: 'LafiseV3',
    component: LafiseV3,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/hn-lafise-3/:code',
    name: 'LafiseV3HN',
    component: LafiseV3HN,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/lafise-txt/:code',
    name: 'LafiseTxt',
    component: LafiseTxt,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/promerica-txt/:code',
    name: 'PromericaTxt',
    component: PromericaTxt,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/lci/:code',
    name: 'LCI',
    component: LCI,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports',
    name: 'MainReports',
    component: MainReports,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'report:list'
    }
  },
  {
    path: '/internal-reports',
    name: 'MainInternalReports',
    component: MainInternalReports,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'report-internal:list'
    }
  },
  {
    path: '/configure-reports',
    name: 'ConfigureReports',
    component: ConfigureReports,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'configure-report:create'
    }
  },
  {
    path: '/reports/magisterio/:code',
    name: 'Magistery',
    component: Magistery,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/bncr/:code',
    name: 'NationalBankCostaRica',
    component: NationalBankCostaRica,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/bncr-sinpe/:code',
    name: 'NationalBankCostaRicaSINPE',
    component: NationalBankCostaRicaSINPE,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/nets/:code',
    name: 'Net',
    component: Net,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/summary-payments/:code',
    name: 'SummaryPayments',
    component: SummaryPayments,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/pagus/:code',
    name: 'Pagus',
    component: Pagus,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/citibank-paylink/:code',
    name: 'PaylinkCR',
    component: PaylinkCR,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/citibank-paylink-hn/:code',
    name: 'PaylinkHN',
    component: PaylinkHN,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/pay-register/:code',
    name: 'PayRegister',
    component: PayRegister,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/standard-payroll/:code',
    name: 'PayrollStandard',
    component: PayrollStandard,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/bps/:code',
    name: 'PrevisionSocialBankUY',
    component: PrevisionSocialBankUY,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/salary-historic/:code',
    name: 'SalaryHistoric',
    component: SalaryHistoric,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/santander-bank-uy/:code',
    name: 'SantanderBankUY',
    component: SantanderBankUY,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/scotiabank/:code',
    name: 'ScotiabankCR',
    component: ScotiabankCR,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/standard-employees/:code',
    name: 'StandardEmployees',
    component: StandardEmployees,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/headcount-regional/:code',
    name: 'HeadcountRegional',
    component: HeadcountRegional,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/standard-vacation/:code',
    name: 'StandardVacation',
    component: StandardVacation,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/vacations-accrual/:code',
    name: 'VacationsAccrual',
    component: VacationsAccrual,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/hn-rap/:code',
    name: 'RAP',
    component: RAP,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/vacation-balance/:code',
    name: 'VacationBalance',
    component: VacationBalance,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/msc-vacations/:code',
    name: 'VacationMSC',
    component: VacationMSC,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/bancomer-232/:code',
    name: 'Bancomer232',
    component: Bancomer232,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/bancomer-108/:code',
    name: 'Bancomer108',
    component: BancomerFile108,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/banamex-c/:code',
    name: 'BanamexTypeC',
    component: BanamexTypeC,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/banamex-d/:code',
    name: 'BanamexD',
    component: BanamexD,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/banamex-paylink-484/:code',
    name: 'BanamexPaylink484',
    component: BanamexPaylink484,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/banamex-pay-485/:code',
    name: 'BanamexPaylink485',
    component: BanamexPaylink485,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/pay-employees/:code',
    name: 'PayEmployees',
    component: PayEmployees,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/infonacot-identification/:code',
    name: 'InfonacotIdentification',
    component: InfonacotIdentification,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/infonacot-certification/:code',
    name: 'InfonacotCertification',
    component: InfonacotCertification,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/infonacot-credit/:code',
    name: 'InfonacotCredit',
    component: InfonacotCredit,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/reports/rent-template/:code',
    name: 'RentTemplate',
    component: RentTemplate,
    meta: {
      auth: true,
      layout: 'home'
    }
  }
]
